/* ⛔ CATEGORIE MASQUEE (07/10/2026, retour de Nawal sur l'icebreaker).
   Dans le formulaire du module (« Catégories : Masquer / SoftSkills »), le
   premier choix « Masquer » ecrit `display: "non"` ; le second, « SoftSkills :
   non », ecrit `value: "non"`. L'ecran de fin de module ne lisait que `value` :
   une categorie que Nawal avait masquee s'affichait quand meme dans « Voici tes
   resultats ». Une categorie est donc masquee a l'apprenant des que l'un OU
   l'autre vaut « non ». Une seule regle, lue par l'ecran de fin et le bilan. */
export const categorieMasquee = (cat) => !!cat && (cat.value === 'non' || cat.display === 'non')

export default categorieMasquee
